export class FormatConverter {
  #formatMapping;
  #formatCache: Record<string, string> = {};

  constructor(formatMapping: Record<string, string>) {
    this.#formatMapping = formatMapping;
  }

  convert(javaFormat: string) {
    return (this.#formatCache[javaFormat] ??= this.#doConvert(javaFormat));
  }

  #doConvert(javaFormat: string) {
    let i = 0;
    let beginIndex = -1;
    let lastChar = null;
    let result = '';

    for (; i < javaFormat.length; i++) {
      const char = javaFormat.charAt(i);

      if (lastChar !== char) {
        result = this.#appendMappedToken(javaFormat, beginIndex, i, result);
        beginIndex = i;
      }

      lastChar = char;
    }

    return this.#appendMappedToken(javaFormat, beginIndex, i, result);
  }

  #appendMappedToken(formatString: string, beginIndex: number, currentIndex: number, result: string) {
    if (beginIndex !== -1) {
      const token = formatString.substring(beginIndex, currentIndex);
      return result + (this.#formatMapping[token] || token);
    }
    return result;
  }
}
